import { motion } from "framer-motion";
import {
  FoliageCluster,
  JasmineGarland,
  ChainDiya,
  VineBranch,
  PalaceArch,
} from "./Ornaments";

const EASE = [0.16, 1, 0.3, 1];

const NAME_LINES = [
  { text: "Divyanshi", cls: "line" },
  { text: "&", cls: "line amp" },
  { text: "Divyashiv", cls: "line" },
];

export default function Hero({ ready, onScrollCue }) {
  return (
    <section className="hero hero-invite" id="top" data-testid="hero-section">
      <div className="hero-foliage hf-tl">
        <FoliageCluster width={310} />
      </div>
      <div className="hero-foliage hf-tr">
        <FoliageCluster width={310} flip />
      </div>

      <div className="hero-gar" style={{ left: "5%" }}>
        <JasmineGarland rows={10} />
      </div>
      <div className="hero-gar g-extra" style={{ left: "11%" }}>
        <JasmineGarland rows={7} delay={1.1} dur={7.6} />
      </div>
      <div className="hero-gar" style={{ right: "5.5%" }}>
        <JasmineGarland rows={8} delay={0.5} dur={8.2} />
      </div>
      <div className="hero-gar g-extra" style={{ right: "11.5%" }}>
        <JasmineGarland rows={11} delay={1.6} dur={6.8} />
      </div>

      <div className="hero-chain" style={{ left: "20%" }}>
        <ChainDiya links={8} width={44} />
      </div>
      <div className="hero-chain" style={{ right: "20%" }}>
        <ChainDiya links={6} width={44} delay={0.8} dur={7.2} />
      </div>

      <div className="hero-arch">
        <PalaceArch width={560} />
      </div>

      <div className="hero-sprig sl">
        <VineBranch width={190} />
      </div>
      <div className="hero-sprig sr">
        <VineBranch width={190} flip />
      </div>
      <span className="hero-bottom-dia" aria-hidden="true" />

      <motion.div
        className="hero-center"
        initial="hidden"
        animate={ready ? "show" : "hidden"}
      >
        <h1 className="names serif" data-testid="hero-names">
          {NAME_LINES.map((l, i) => (
            <span className="mask" key={l.text}>
              <motion.span
                className={l.cls}
                variants={{
                  hidden: { y: "115%" },
                  show: {
                    y: "0%",
                    transition: { duration: 1.3, ease: EASE, delay: 0.25 + i * 0.16 },
                  },
                }}
              >
                {l.text}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.div
          className="hero-date"
          data-testid="hero-date"
          variants={{
            hidden: { opacity: 0, y: 18 },
            show: {
              opacity: 1,
              y: 0,
              transition: { duration: 1, ease: EASE, delay: 1.05 },
            },
          }}
        >
          <span className="date-rule" />
          26th November 2026
          <span className="date-rule" />
        </motion.div>
      </motion.div>

      <motion.button
        className="hero-scroll-line"
        data-testid="hero-scroll-cue"
        onClick={onScrollCue}
        aria-label="Scroll to discover"
        initial={{ opacity: 0 }}
        animate={ready ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 1, delay: 1.6 }}
      >
        <span className="scroll-line">
          <span className="scroll-dot" />
        </span>
      </motion.button>
    </section>
  );
}
